/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2022 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
/**
 * GridContainerStyles contaniner styles
 *
 * @file GridContainerStyles.js
 * @author Mohamed Yasar arabath M
 * @since 0.0.2
 */

import mixins from '../../../../assets/styles/mixins.scss';


const GridContainerStyles = (theme, props) => {
  const { columns, spacing, cardWidth } = props;
  const gridStyles = {
    gridContainer: {
      display: 'grid',
      width: 'inherit'
    }
  };
  const defaultBreakponits = {
    xs: 1, md: 2, mlg: 2, lg: 3, xl: 3, xxl: 4
  };
  const defaultGap = '24px';
  const defaultCardWidth = {
    auto: '1fr',
    minMax: { min: 'auto', max: 'auto' }
  };
  const getCardWidth = () => {
    let frame = defaultCardWidth.auto;
    if (!cardWidth || cardWidth === 'auto') {
      frame = defaultCardWidth.auto;
    } else if (cardWidth && Object.keys(cardWidth).length !== 0) {
      const minMax = { ...defaultCardWidth.minMax, ...cardWidth };
      frame = `minmax(${minMax.min}px, ${minMax.max}px)`;
    } else if (cardWidth && typeof cardWidth === 'number') {
      frame = `minmax(${cardWidth}px, ${cardWidth}px)`;
    }

    return frame;
  };
  const frame = getCardWidth();
  const getGridTemplateColumns = () => {
    const gridColumns = {};
    let breakponits = defaultBreakponits;
    if (columns && Object.keys(columns).length !== 0) {
      breakponits = { ...defaultBreakponits, ...columns };
    }
    const minMax = [
      [mixins['ml-max'], breakponits.xs],
      [mixins['ml-md'], breakponits.xs],
      [mixins['md-mlg'], breakponits.md],
      [mixins['mlg-lg'], breakponits.mlg],
      [mixins['lg-xl'], breakponits.lg],
      [mixins['xl-xxl'], breakponits.xl],
      [mixins['xxl-min'], breakponits.xxl]
    ];
    minMax.forEach(([meidaQuery, numberOfCol]) => {
      gridColumns[meidaQuery] = { gridTemplateColumns: `repeat(${numberOfCol}, ${frame})` };
    });

    return gridColumns;
  };
  const gap = (typeof spacing === 'number' && `${spacing}px`) || defaultGap;
  let gridTemplateColumns = {};
  if (typeof columns === 'number') {
    gridTemplateColumns = { gridTemplateColumns: `repeat(${columns}, ${frame})` };
  } else {
    gridTemplateColumns = getGridTemplateColumns();
  }
  if (gap) {
    gridStyles.gridContainer.gap = gap;
  }
  if (gridTemplateColumns) {
    gridStyles.gridContainer = { ...gridStyles.gridContainer, ...gridTemplateColumns };
  }

  return gridStyles;
};
export default GridContainerStyles;

